"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedActionsContainer = exports.ProviderCardList = exports.Container = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const provider_components_1 = require("@kyruus/provider-components");
const ui_theme_1 = require("@kyruus/ui-theme");
const LIST_MAX_HEIGHT_LG = '140px';
const LIST_MAX_HEIGHT_MD = '140px';
exports.Container = (0, styled_1.default)('div') `
  position: sticky;
  bottom: 0;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;
  justify-content: space-between;
  column-gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  background-color: ${(0, ui_theme_1.fromTheme)('color_background_secondary')};
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    flex-flow: row nowrap;
  }
`;
exports.ProviderCardList = (0, styled_1.default)(provider_components_1.MiniProviderBookAndReferList) `
  overflow-y: auto;
  & > ul {
    row-gap: ${(0, ui_theme_1.fromTheme)('spacing_xlarge')};
  }
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    max-height: ${LIST_MAX_HEIGHT_MD};
    overflow-y: auto;
    & > ul {
      padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
      row-gap: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
    }
    & > span {
      position: sticky;
      top: 0;
    }
  }
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_large')}) {
    max-height: ${LIST_MAX_HEIGHT_LG};
    overflow-y: auto;
  }
`;
exports.RelatedActionsContainer = (0, styled_1.default)('div') `
  padding: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  flex: 0 1 auto;
  position: sticky;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  background-color: ${(0, ui_theme_1.fromTheme)('color_background')};
  border-top: ${(0, ui_theme_1.fromTheme)('border_width')} ${(0, ui_theme_1.fromTheme)('border_style')}
    ${(0, ui_theme_1.fromTheme)('color_border')};
  @media screen and (min-width: ${(0, ui_theme_1.fromTheme)('screen_medium')}) {
    width: auto;
    border: none;
    background-color: inherit;
  }
`;
//# sourceMappingURL=ProviderReferralList.styles.js.map